<template>
  <v-container fluid grid-list-md>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-tooltip bottom>
          <v-btn slot="activator" color="primary" @click="create" class="mb-4" :disabled="task_shared || !checkPermission('calendar', 'create')">
            {{this.translate('system.button.add.title')}}
            <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
          </v-btn>
          <span>{{createTooltipText}}</span>
        </v-tooltip>
      </v-flex>
      <!--Dialog para confirmação de exclusão-->
      <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
      <!--Index-->
      <v-flex xs12>
        <v-card>
          <v-list two-line subheader :search="search">
            <v-layout>
              <v-flex xs10>
                <v-subheader>Descrição</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-subheader>Ações</v-subheader>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <template v-for="(item, index) in items">
              <v-list-tile :key="index">
                <v-list-tile-content>
                  <v-list-tile-title><span style="font-weight:600">{{item.user['id_text'].split(' ').slice(0, 2).join(' ')}}</span><span style="color: gray; font-size:12px;"> - {{moment.duration(moment(item.end).diff(item.begin)).format('hh [hrs] mm [min] ss [seg]')}}</span></v-list-tile-title>
                  <v-list-tile-title>{{ item.begin | formatDateTime }} até {{ item.end | formatDateTime }}</v-list-tile-title>
                  <v-list-tile-sub-title><v-checkbox v-model="item.all_day" class="ma-0 pt-0 pb-1" hide-details readonly label="Dia inteiro"></v-checkbox></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-layout align-center row>
                    <v-tooltip bottom>
                      <v-btn slot="activator" icon class="mx-0" @click="editItem(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id) || !checkPermission('calendar', 'edit')">
                        <v-icon color="teal">edit</v-icon>
                      </v-btn>
                      <span>{{ editTooltipText }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn slot="activator" icon class="mx-0" @click="dialogDelete(item)" :disabled="task_shared || (!task.crud_access && item.user_id !== $auth.user().id) || !checkPermission('calendar', 'delete')">
                        <v-icon color="pink">delete</v-icon>
                      </v-btn>
                      <span>{{ deleteTooltipText }}</span>
                    </v-tooltip>
                  </v-layout>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="index + 1000" v-if="index + 1 < items.length"></v-divider>
            </template>
            <v-list-tile three-line v-if="items.length === 0">
              {{emptyTable}}
            </v-list-tile>
            <v-divider></v-divider>
            <v-layout align-center fill-height>
              <v-flex xs3>
                <v-subheader>Total</v-subheader>
              </v-flex>
              <v-flex xs9>
                <strong>{{getSum}}</strong>
              </v-flex>
            </v-layout>
          </v-list>
        </v-card>

        <!-- <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :search="search"
          :items="items"
          :rows-per-page-items="[10,20,30,{'text':'Todos','value':-1}]"
          class="elevation-1"
          :pagination.sync="pagination"
          :custom-filter="customizedFilter"  style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.user.id_text + (props.item.company_id !== task.company_id ? (' ('+props.item.company.id_text+')') : '')}}</td>
            <td>{{ props.item.begin | formatDateTime }}</td>
            <td>{{ props.item.end | formatDateTime }}</td>
            <td>{{moment.duration(moment(props.item.end).diff(props.item.begin)).format('D [dias] hh [hrs] mm [min]')}}</td>
            <td>
              <v-checkbox
                v-model="props.item.all_day" readonly class="mx-auto"
              ></v-checkbox>
            </td>
            <td align="center" style="min-width: 120px">
              <v-tooltip bottom>
                <v-btn slot="activator" icon class="mx-0" @click="editItem(props.item)" :disabled="task_shared || (!task.crud_access && props.item.user_id !== $auth.user().id) || !checkPermission('calendar', 'edit')">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <span>{{ editTooltipText }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn slot="activator" icon class="mx-0" @click="dialogDelete(props.item)" :disabled="task_shared || (!task.crud_access && props.item.user_id !== $auth.user().id) || !checkPermission('calendar', 'delete')">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
                <span>{{ deleteTooltipText }}</span>
              </v-tooltip>
            </td>
          </template>
          <template slot="footer">
            <td>
              <strong class="subheading">Total</strong>
            </td>
            <td>
            </td>
            <td colspan="45%">
              <strong class="subheading">{{getSum}}</strong>
            </td>
          </template>
        </v-data-table> -->
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{this.view === 2 ? this.translate('system.title.include') : this.translate('system.title.edit')}} Horário</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" ref="form" @keyup.native.esc="close" @keyup.native.ctrl.enter="save()">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12 sm4>
                  <p-date-time
                               :label="translate('table.' + entity + '.field.begin')"
                               :timePicker="!editedItem.all_day"
                               @blur="cleanValidate"
                               v-model="editedItem.begin"
                               :rules="dateDiffRule(true, translate('table.' + entity + '.field.begin'), editedItem.begin, editedItem.end, true)"
                  >
                  </p-date-time>
                </v-flex>
                <v-flex xs12 sm4>
                  <p-date-time
                               :label="translate('table.' + entity + '.field.end')"
                               :timePicker="!editedItem.all_day"
                               @blur="cleanValidate"
                               v-model="editedItem.end"
                               :rules="dateDiffRule(true, translate('table.' + entity + '.field.end'), editedItem.begin, editedItem.end, true)"
                  >
                  </p-date-time>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field readonly="" :label="translate('table.' + entity + '.field.duration')"
                                :value="duration">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch :label="translate('table.' + entity + '.field.all_day')" v-model="editedItem.all_day"
                            @change="changeAllDay"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="save()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import crud from './../../mixin/crud'
  import access from './../../mixin/access'
  import tooltip from './../../mixin/tooltip'
  import rules from './../../mixin/rules'
  import PDateTime from './../shared/PDateTime'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  import PConfirm from './../shared/PConfirm'

  momentDurationFormatSetup(moment)
  export default {
    mixins: [crud, rules, access, tooltip],
    components: {
      PDateTime,
      PConfirm
    },
    data: () => ({
      tooltip_entity: 'calendar',
      entity: 'task_calendar',
      pagination: {
        sortBy: 'begin'
      }
    }),
    name: 'TaskCalendar',
    props: {
      task: Object,
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      this.items = this.task.calendar
      this.$emit('itemsLength', this.items.length)
      this.editedItem = {
        task_id: this.task.id,
        begin: '',
        end: '',
        all_day: false
      }
      this.defaultItem = {
        task_id: this.task.id,
        begin: '',
        end: '',
        all_day: false
      }
    },
    created () {
      this.pagination.descending = !this.pagination.descending
    },
    methods: {
      allowed: v => v === 0,
      cleanValidate (value) {
        setTimeout(() => {
          this.$refs.form.validate()
        }, 100)
      },
      afterInsert (item) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: item,
          details: 'calendar',
          responseEvent: 'addSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        // Adiciona o evento na tela de calendário
        let event = {
          id: item.id,
          task_id: item.task.id,
          user_id: item.user_id,
          task: item.task,
          company_id_text: item.company.id_text,
          company_id: item.company.id,
          id_text: item.user.id_text,
          user: item.user,
          company: item.company,
          title: item.task.id + ' - ' + item.task.id_text,
          start: item.begin,
          category_id_text: item.task.category_id ? item.task.category.id_text : null,
          end: item.end,
          type: 1,
          color: null,
          allDay: !!item.all_day
        }
        for (let user in this.task.participants) {
          this.$socket.emit('generalEvent', {
            data: event,
            notBroadcast: true,
            responseEvent: 'addSocketCalendar',
            room: `calendar${this.task.participants[user]}`
          })
        }
      },
      afterUpdate (item) {
        this.$socket.emit('generalDetailsEvent', {
          data: item,
          details: 'calendar',
          responseEvent: 'editSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        // Edita o evento na tela de calendário
        for (let user in this.task.participants) {
          this.$socket.emit('generalEvent', {
            data: {id: item.id, start: item.begin, end: item.end, allDay: item.all_day, team_id: item.task.team_id, user_id: item.user_id},
            notBroadcast: true,
            responseEvent: 'editSocketCalendar',
            room: `calendar${this.task.participants[user]}`
          })
        }
      },
      afterDelete (item) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: item,
          details: 'calendar',
          responseEvent: 'deleteSocketDetails',
          room: `tasks${this.task.id}_manage`
        })
        // Deleta o evento na tela de calendário
        for (let user in this.task.participants) {
          this.$socket.emit('generalEvent', {
            data: {id: item.id, user_id: item.user_id, team_id: item.task.team_id},
            notBroadcast: true,
            responseEvent: 'deleteSocketCalendar',
            room: `calendar${this.task.participants[user]}`
          })
        }
      },
      changeAllDay (val) {
        if (val) {
          if (this.editedItem.end && this.editedItem.end.split(' ')[1] !== '00:00') {
            this.editedItem.end = moment(this.editedItem.end).add(1, 'days').format('YYYY-MM-DD HH:mm')
          }
        }
        this.editedItem.begin = this.editedItem.begin === '' ? '' : moment(this.editedItem.begin).format(val ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm')
        this.editedItem.end = this.editedItem.end === '' ? '' : moment(this.editedItem.end).format(val ? 'YYYY-MM-DD 00:00' : 'YYYY-MM-DD HH:mm')
        if (this.editedItem.begin === '' || this.editedItem.end === '') {
          this.$refs.form.resetValidation()
        }
      }
    },
    computed: {
      duration: function () {
        if (this.editedItem.all_day) {
          return moment.duration(moment(this.editedItem.end).diff(this.editedItem.begin)).format('D [dias]')
        } else {
          return moment.duration(moment(this.editedItem.end).diff(this.editedItem.begin)).format('hh [hrs] mm [min]')
        }
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.user_id'), value: 'user.id_text', width: '25%'},
          {text: this.translate('table.' + this.entity + '.field.begin'), value: 'begin', width: '20%'},
          {text: this.translate('table.' + this.entity + '.field.end'), value: 'end', width: '20%'},
          {text: this.translate('table.' + this.entity + '.field.duration'), value: 'duration', width: '20%'},
          {text: this.translate('table.' + this.entity + '.field.all_day'), value: 'all_day', width: '5%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center', width: '10%'}
        ]
      },
      getSum: function () {
        let total = 0
        this.items.forEach(function (value) {
          total = total + moment(value.end).diff(moment(value.begin))
        })
        return moment.duration(total, 'milliseconds').format('D [dias] hh [hrs] mm [min]')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TaskCalendar.vue